import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AllRoutes from "./AllRoutes";
import { addToken} from "./Redux/Reducers/authReducer";
import LoginLoader from "./Loader/LoginLoader";
import { UserProvider } from "./Context/UserContext";
import { PermissionProvider } from "./Context/PermissionContext";

function App() {
  const { token, loading } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addToken());
  }, [dispatch]);



  return (
    <UserProvider>
      <PermissionProvider>
        {loading && <LoginLoader />}
        <AllRoutes token={token} />
      </PermissionProvider>
    </UserProvider>
  );
}

export default App;
